<ion-grid>
  <ion-row>
    <ion-col>
      <p class="charge-plan-title">
        <strong>Ladeplan</strong>
      </p>
      <div *ngIf="!meetsConsideration">
        <p class="text-left small-text">
          <ion-icon name="warning" class="warning-icon"></ion-icon>

          {{
            smartChargeStatus?.consideration?.isPluggedIn === false
              ? 'Smartlading krever at bilen er tilkoblet laderen på en kjent ladelokasjon.'
              : smartChargeStatus?.consideration?.atChargingLocation === false
              ? 'Smartlading krever at bilen er på en kjent ladelokasjon. Hvis du akkurat ankom, vent et par minutter så vi kan hente lokasjonen.'
              : smartChargeStatus?.consideration?.isCharging === false
              ? 'Bilen din må lade et par minutter før vi kan lage ladeplanen. Vennligst sjekk at bilen din lader.'
              : smartChargeStatus?.consideration?.hasTimeEstimate === false
              ? 'Vi overvåker ladehastigheten for å lage ladeplan til deg. Ladingen vil stoppe så snart ladeplanen er klar.'
              : 'Vi jobber med å lage en ladeplan til deg'
          }}
        </p>
      </div>
      <div *ngIf="isOverridden">
        <p class="text-left small-text">
          <ion-icon name="warning" class="warning-icon"></ion-icon>
          Du har overstyrt ladeplanen. Trykk på «Gjenoppta ladeplan» for å aktivere den igjen. 
        </p>
      </div>
      <div class="charge-policy">
        <div
          class="smart-charge-enabled"
          [class.smart-charge-disabled]="!policyEnabled"
        >
          <div>
            <p><strong>Smartlading</strong></p>
            <p>Lad når strømmen er billigst</p>
          </div>
          <ion-toggle
            [(ngModel)]="policyEnabled"
            [disabled]="isOverridden || !vehicle.capabilities.smartCharging.isCapable"
            (ngModelChange)="toggleSmartCharging()"
          >
            {{ policyEnabled ? 'På' : 'Av' }}
          </ion-toggle>
        </div>
        <div>
          <app-deadline-picker
            *ngIf="policyEnabled"
            [deadline]="deadline"
            [isOverridden]="isOverridden"
            (emitSelectedTime)="setDeadline($event)"
          ></app-deadline-picker>
        </div>
        <div
          *ngIf="
            vehicle.smartChargingPolicy.isEnabled &&
            (!vehicle.chargeState.isPluggedIn || vehicle.locationId === null)
          "
        >
          <p class="small-text pi-2">
            En ladeplan vil bli opprettet når bilen lader på en kjent
            ladelokasjon.
          </p>
        </div>
        <div *ngIf="hasSmartChargePlan">
          <p class="smart-charge-status">
            Lading vil starte <strong>{{ smartChargeStart }}</strong> og være
            ferdig rundt <strong>{{ smartChargeEnd }}</strong>
            {{ smartChargeEndsTomorrow ? ' i morgen' : '' }}
          </p>
          <app-chart
            *ngIf="smartChargeStatus.plan.smartCost"
            [startTime]="startTime"
            [endTime]="endTime"
            [deadline]="vehicle.smartChargingPolicy.deadline"
            [locationId]="vehicle.locationId"
          ></app-chart>
          <ion-accordion-group
            class="smart-charge-accordion"
            (ionChange)="accordionGroupChange($event)"
          >
            <ion-accordion>
              <ion-item slot="header">
                <ion-label>
                  {{ accordionExpanded ? 'Vis mindre' : 'Vis mer detaljer' }}
                </ion-label>
              </ion-item>
              <div slot="content" class="smart-charge-details">
                <div class="details-item">
                  <p>Lading pauset</p>
                  <p>
                    <strong>{{ smartChargePaused }}</strong>
                  </p>
                </div>
                <div class="details-item">
                  <p>Lading starter</p>
                  <p>
                    <strong>{{ smartChargeStart }}</strong>
                  </p>
                </div>
                <div class="details-item">
                  <p>Lading ferdig</p>
                  <p>
                    <strong>{{ smartChargeEnd }}</strong>
                  </p>
                </div>
                <div class="details-item">
                  <p>Estimert ladetid</p>
                  <p>
                    <strong>{{ estimatedSmartChargeTime }}</strong>
                  </p>
                </div>
                <div class="details-item">
                  <p>Estimert ladekostnad</p>
                  <p>
                    <strong>{{
                      estimatedSmartChargeCost !== undefined
                        ? estimatedSmartChargeCost + ' kr'
                        : 'Kommer*'
                    }}</strong>
                  </p>
                </div>
                <div class="details-item">
                  <p>
                    Estimert besparelse
                    <ion-icon
                      name="help-circle-outline"
                      class="help-icon"
                      (click)="openHelpCost()"
                    ></ion-icon>
                  </p>
                  <p>
                    <strong>{{
                      estimatedSmartChargeSavings !== undefined
                        ? estimatedSmartChargeSavings + ' kr'
                        : 'Kommer*'
                    }}</strong>
                  </p>
                </div>
                <div *ngIf="estimatedSmartChargeSavings === undefined">
                  <p>
                    *Spotprisen for i morgen er ikke tilgjengelig. Sjekk igjen
                    senere.
                  </p>
                </div>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </div>
        <p class="error-msg" *ngIf="policyErrorMessage">
          {{ policyErrorMessage }}
        </p>
        <p class="success-msg" *ngIf="policySuccessMessage">
          {{ policySuccessMessage }}
        </p>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
